export const HO_FAVICONS = {
  16: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-16.png',
  32: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-32.png',
  48: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-48.png',
};
